/*
 * Toplu alım kademeleri (volume tiers)
 * ------------------------------------
 * Minimog'un stok dosyası DEĞİLDİR — RimaPeçete'ye özel eklendi.
 *
 * Kademe seçimini ürün formundaki adet alanına bağlar ve adet fiyatını
 * canlı hesaplar. Hesap, Yanet Volume Discount fonksiyonunun sepette
 * uyguladığı tutarla BİREBİR aynı olmak zorunda:
 *
 *   birim indirimi = floor(fiyat_kurus * yuzde / 100)   // kuruş, aşağı yuvarlanır
 *   birim fiyat    = fiyat_kurus - birim indirimi
 *
 * 2026-08-19 doğrulaması, 149,90₺ ürün, 5 adet, %5:
 *   floor(14990 * 5 / 100) = 749 -> birim 14241 -> satır 71205
 *   sepetin döndürdüğü line_price: 71205  ✓
 * Standart yuvarlama (749,5 -> 750) tutmuyordu; aşağı yuvarlama şart.
 * Yanet'te kademeler değişirse bu dosya değil, bloğun ayarları güncellenir.
 */

class RpVolumeTiers extends HTMLElement {
  connectedCallback() {
    const config = this.querySelector('[data-rp-tiers-config]');
    if (!config) return;

    try {
      const parsed = JSON.parse(config.textContent);
      this.tiers = parsed.tiers || [];
      this.variantPrices = parsed.variants || {};
      this.strings = parsed.strings || {};
    } catch (error) {
      return;
    }

    if (!this.tiers.length) return;

    this.price = Number(this.dataset.price) || 0;
    this.updatePrice = this.dataset.updatePrice !== 'false';
    this.hint = this.querySelector('[data-rp-tiers-hint]');
    this.hintInner = this.querySelector('[data-rp-tiers-hint-inner]');

    this.onTierChange = this.onTierChange.bind(this);
    this.onQuantityChange = this.onQuantityChange.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
    this.applyStartQty = this.applyStartQty.bind(this);

    this.addEventListener('change', this.onTierChange);
    document.addEventListener('variant:changed', this.onVariantChange);

    /*
     * Tema, adet alanının sınırlarını kurarken değeri KOŞULSUZ minimuma
     * çekiyor (MQuantityInput.setQuantityBoundries, product-info.js'ten
     * çağrılıyor) ve arkasından bu olayı yayıyor. Varsayılan kademeyi tek
     * seferlik yazmak bu yüzden yetmiyor — sıfırlamadan sonra tekrar
     * uygulanması gerekiyor.
     */
    this.quantityUpdateEvent = window.MinimogTheme?.pubSubEvents?.quantityUpdate;
    if (window.MinimogEvents && this.quantityUpdateEvent) {
      window.MinimogEvents.subscribe(this.quantityUpdateEvent, this.applyStartQty);
    }

    // Mobilde daraltılmış başlık: dokununca aç/kapat.
    this.toggle = this.querySelector('[data-rp-tiers-toggle]');
    if (this.toggle) {
      this.mobileQuery = window.matchMedia('(max-width: 767px)');
      this.toggle.addEventListener('click', () => this.setCollapsed(!this.classList.contains('is-collapsed')));
      this.mobileQuery.addEventListener('change', () => this.syncToggleAria());
      this.syncToggleAria();
    }

    // Adet alanı bu bloktan SONRA render ediliyor; ilk eşitlemeyi
    // DOM hazır olduktan sonra yapıyoruz.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.bindQuantityInput(), { once: true });
    } else {
      this.bindQuantityInput();
    }
  }

  setCollapsed(collapsed) {
    this.classList.toggle('is-collapsed', collapsed);
    this.syncToggleAria();
  }

  /* Masaüstünde liste CSS ile hep açık; aria bunu yansıtsın. */
  syncToggleAria() {
    if (!this.toggle) return;
    const onMobile = this.mobileQuery ? this.mobileQuery.matches : true;
    const expanded = onMobile ? !this.classList.contains('is-collapsed') : true;
    this.toggle.setAttribute('aria-expanded', String(expanded));
  }

  disconnectedCallback() {
    document.removeEventListener('variant:changed', this.onVariantChange);
    if (window.MinimogEvents && this.quantityUpdateEvent) {
      window.MinimogEvents.unSubscribe(this.quantityUpdateEvent, this.applyStartQty);
    }
    if (this.boundInput) this.boundInput.removeEventListener('change', this.onQuantityChange);
    if (this.totalNode) this.totalNode.remove();
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  /*
   * Varyant değişiminde tema adet alanını yeniden basabiliyor, bu yüzden
   * düğüm önbelleğe alınmaz — her seferinde yeniden aranır.
   */
  get quantityInput() {
    return (
      document.getElementById(`Quantity-${this.sectionId}`) ||
      this.closest('product-info')?.querySelector('m-quantity-input input[name="quantity"]') ||
      document.querySelector(`#QuantityForm-${this.sectionId} input[name="quantity"]`)
    );
  }

  bindQuantityInput() {
    const input = this.quantityInput;
    if (!input) return;

    if (this.boundInput && this.boundInput !== input) {
      this.boundInput.removeEventListener('change', this.onQuantityChange);
    }
    if (this.boundInput !== input) {
      input.addEventListener('change', this.onQuantityChange);
      this.watchUserGestures(input);
      this.boundInput = input;
    }

    if (this.applyStartQty()) return;

    this.sync(this.currentQuantity());
  }

  /*
   * Açılışta seçili gelmesi istenen paket adedini adet alanına yazar.
   * Müşteri adede kendi dokunduysa bir daha dayatmaz. true dönerse çağıran
   * sync'i atlar: dispatch edilen change olayı zaten yeniden tetikliyor.
   */
  applyStartQty() {
    if (this.userTouched) return false;

    const input = this.quantityInput;
    if (!input) return false;

    const start = parseInt(this.dataset.startQty, 10);
    if (!Number.isFinite(start) || start <= 0) return false;
    if (start === this.currentQuantity()) return false;

    input.value = String(start);
    input.dispatchEvent(new Event('change', { bubbles: true }));

    // Tema bu turdan sonra fiyat bloğunu yeniden basabiliyor; bir kare
    // bekleyip kademe fiyatını üstüne yazıyoruz (onVariantChange'deki
    // aynı sebep).
    requestAnimationFrame(() => {
      this.mirrorSecondaryInputs(start);
      this.sync(this.currentQuantity());
    });
    return true;
  }

  /*
   * Yapışkan çubuğun kendi adet alanı sunucudan gelen değerle (1) render
   * ediliyor ve açılıştaki programatik yazmayı kaçırıyor. Kademeye tıklandığında
   * tema kendisi eşitliyor; açılışta biz eşitliyoruz ki iki form aynı adedi
   * göstersin.
   */
  mirrorSecondaryInputs(quantity) {
    const main = this.quantityInput;
    document.querySelectorAll('input[name="quantity"]').forEach((el) => {
      if (el === main || !el.closest('form[action$="/cart/add"]')) return;
      if (el.value !== String(quantity)) el.value = String(quantity);
    });
  }

  /* Adede elle dokunulduysa varsayılan bir daha geri yazılmasın. */
  watchUserGestures(input) {
    const mark = (event) => {
      if (event.isTrusted) this.userTouched = true;
    };
    const widget = input.closest('m-quantity-input') || input.parentElement || input;
    ['click', 'input', 'keydown'].forEach((type) => widget.addEventListener(type, mark, true));
  }

  currentQuantity() {
    const input = this.quantityInput;
    const value = input ? parseInt(input.value, 10) : NaN;
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  /* Seçili kademe: adedi geçmeyen en yüksek kademe. */
  activeIndex(quantity) {
    let index = -1;
    this.tiers.forEach((tier, i) => {
      if (quantity >= tier.qty) index = i;
    });
    return index;
  }

  onTierChange(event) {
    const radio = event.target.closest('[data-rp-tier-radio]');
    if (!radio) return;

    // Kademe seçmek de bir tercihtir; varsayılan artık dayatılmaz.
    this.userTouched = true;

    const quantity = parseInt(radio.value, 10);
    const input = this.quantityInput;
    if (!input || !Number.isFinite(quantity)) return;

    input.value = String(quantity);
    // m-quantity-input sticky ATC ile eşitlemeyi bu olayla yapıyor.
    input.dispatchEvent(new Event('change', { bubbles: true }));
    this.sync(quantity);
  }

  onQuantityChange() {
    this.bindQuantityInput();
    this.sync(this.currentQuantity());
  }

  onVariantChange(event) {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;

    const price = this.variantPrices[variant.id] ?? variant.price;
    if (typeof price === 'number' && price > 0) {
      this.price = price;
      this.renderPrices();
    }
    // Tema fiyat bloğunu bu olaydan sonra yeniden basabiliyor; bir kare
    // bekleyip üstüne yazıyoruz, yoksa kademe fiyatı geri alınıyor.
    requestAnimationFrame(() => this.bindQuantityInput());
  }

  sync(quantity) {
    const active = this.activeIndex(quantity);

    this.querySelectorAll('[data-rp-tier-radio]').forEach((radio, index) => {
      radio.checked = index === active;
    });

    this.renderHint(quantity, active);
    this.renderProductPrice(quantity, active);
  }

  get priceContainer() {
    return document.getElementById(`Price-${this.sectionId}`);
  }

  /* Seçili kademedeki birim fiyat; kademe yoksa ürünün kendi fiyatı. */
  unitPriceFor(active) {
    const tier = active >= 0 ? this.tiers[active] : null;
    if (!tier || !tier.pct) return this.price;
    return this.price - Math.floor((this.price * tier.pct) / 100);
  }

  /*
   * Ürün fiyatını seçili kademeye göre yazar. Üstü çizili liste fiyatına
   * dokunmaz — sadece geçerli fiyat değişir.
   */
  renderProductPrice(quantity, active) {
    if (!this.updatePrice) return;

    const container = this.priceContainer;
    if (!container) return;

    const unit = this.unitPriceFor(active);
    const target =
      container.querySelector('.m-price__sale .m-price-item--sale') ||
      container.querySelector('.m-price__regular .m-price-item--regular');
    if (target) target.innerHTML = this.money(unit);

    this.renderUnitNote(unit);
    this.renderTotal(quantity, unit);
  }

  /*
   * Fiyatın altındaki "adedi X₺" notu (snippets/product-prices.liquid).
   * Kademe seçilince paket fiyatı düşüyor, notun da düşmesi gerekiyor;
   * yoksa 119,92₺ paketin altında hâlâ 7,50₺ yazıyor.
   * Bölen ve metin kalıbı işaretlemeden geliyor — burada peçeteye özgü
   * sabit yok, etiketi olmayan üründe düğüm zaten bulunmuyor.
   */
  renderUnitNote(unit) {
    const container = this.priceContainer;
    if (!container) return;

    const note = container.querySelector('[data-rp-unit-note][data-rp-unit-divisor]');
    if (!note) return;

    const divisor = Number(note.dataset.rpUnitDivisor);
    const template = note.dataset.rpUnitTemplate;
    if (!template || !Number.isFinite(divisor) || divisor <= 0) return;

    // money() para birimi uygulamasının <span class="cvc-money"> sarmalını
    // döndürüyor, o yüzden textContent kullanılamıyor. Kalıbı kaçırıp yalnız
    // paranın biçimlendirmesini geçiriyoruz — sunucudan gelen iki değer de
    // kullanıcı girdisi değil.
    note.innerHTML = this.fill(this.escapeHtml(template), {
      price: this.money(Math.round(unit / divisor)),
    });
  }

  escapeHtml(value) {
    const map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    return String(value).replace(/[&<>"']/g, (char) => map[char]);
  }

  /* Toplam satırı yalnız birden fazla paket seçiliyken anlamlı. */
  renderTotal(quantity, unit) {
    const container = this.priceContainer;
    if (!container || !this.strings.total) return;

    if (!this.totalNode) {
      this.totalNode = document.createElement('div');
      this.totalNode.className = 'rp-total';
    }
    const node = this.totalNode;

    if (quantity <= 1) {
      node.remove();
      return;
    }

    node.innerHTML = this.fill(this.strings.total, {
      count: quantity,
      amount: `<strong>${this.money(unit * quantity)}</strong>`,
    });

    if (!node.isConnected) {
      const tax = container.parentElement && container.parentElement.querySelector('.m-product-tax');
      (tax || container).insertAdjacentElement('afterend', node);
    }
  }

  renderPrices() {
    this.querySelectorAll('[data-rp-tier]').forEach((row) => {
      const tier = this.tiers[Number(row.dataset.rpTier)];
      if (!tier) return;

      const unitDiscount = Math.floor((this.price * tier.pct) / 100);
      const unitPrice = this.price - unitDiscount;

      const unitEl = row.querySelector('[data-rp-tier-unit]');
      if (unitEl) unitEl.innerHTML = this.money(unitPrice);

      const saveEl = row.querySelector('[data-rp-tier-save]');
      if (saveEl) {
        saveEl.innerHTML = unitDiscount
          ? this.fill(this.strings.save, { amount: this.money(unitDiscount * tier.qty) })
          : '';
      }
    });
  }

  renderHint(quantity, active) {
    if (!this.hint || !this.hintInner) return;

    const next = this.tiers[active + 1];
    let text = '';

    if (next) {
      text = this.fill(this.strings.hintNext, {
        count: `<mark>${next.qty - quantity}</mark>`,
        percent: next.pct,
      });
    } else if (active >= 0 && this.tiers[active].pct > 0) {
      text = this.strings.hintMax || '';
    }

    this.hintInner.innerHTML = text;
    this.hint.classList.toggle('is-visible', text !== '');
  }

  fill(template, values) {
    if (!template) return '';
    return String(template).replace(/\[(\w+)\]/g, (match, key) =>
      Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match
    );
  }

  money(cents) {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents, window.MinimogSettings && window.MinimogSettings.money_format);
    }
    return (cents / 100).toFixed(2);
  }
}

if (!customElements.get('rp-volume-tiers')) {
  customElements.define('rp-volume-tiers', RpVolumeTiers);
}
